import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';

// wraps a function with scope.$apply, if already applied just return
function applied(fn, scope) {
  if (fn.wrappedInApply) {
    return fn;
  }
  var wrapped = (...args) => {
    var phase = scope.$root.$$phase;
    if (phase === '$apply' || phase === '$digest') {
      return fn(...args);
    }
    return scope.$apply(() => fn(...args));
  };
  wrapped.wrappedInApply = true;
  return wrapped;
}

function applyFunctions(obj, scope) {
  return Object.keys(obj || {}).reduce((prev, key) => {
    var value = obj[key];
    prev[key] = angular.isFunction(value) ? applied(value, scope) : value;
    return prev;
  }, {});
}
// render React component, with scope[attrs.props] being passed in as the component props
function renderComponent(component, props, scope, elem) {
// eslint-disable-next-line react/no-render-return-value
  scope.$evalAsync(() => ReactDOM.render(React.createElement(component, props), elem[0]));
}

function withDomNode(domNode) {
  return class WithDomNode extends React.Component {
    componentDidMount() {
      // eslint-disable-next-line react/no-find-dom-node
      let el = ReactDOM.findDOMNode(this);
      ReactDOM.unmountComponentAtNode(el);
      angular.element(el).after(domNode);
      el.remove();
    }

    render() {
      return <div />;
    }
  };
}

var reactDirective = () => {
  return (reactComponent, bindings, mapBindingsToProps) => {
    var directive = {
      restrict: 'E',
      replace: true,
      transclude: true,
      controller: () => {},
      controllerAs: 'bindings',
      bindToController: true,
      link: (scope, elem, attrs, controller, transcludeFn) => {
        let ChildrenComponent = withDomNode(transcludeFn());

        var renderMyComponent = () => {
          var scopeProps = applyFunctions(scope.bindings, scope);
          if (mapBindingsToProps) {
            scopeProps = mapBindingsToProps(scopeProps);
          }
          scopeProps.children = <ChildrenComponent />;
          renderComponent(reactComponent, scopeProps, scope, elem);
        };

        scope.$watch('bindings', renderMyComponent, true);
        scope.$on('$destroy', () => ReactDOM.unmountComponentAtNode(elem[0]));
      }
    };
    var propTypes = Object.keys(reactComponent.propTypes || {});
    var baseBindings = {};
    propTypes.forEach(pt => baseBindings[pt] = '=');
    directive.scope = angular.extend({}, baseBindings, bindings);
    return directive;
  };
};

// create the end module without any dependencies, including reactComponent and reactDirective
angular
  .module('react', [])
  .factory('reactDirective', [reactDirective]);
